// Which stacked surface owns the keyboard: window key handlers otherwise resolve
// by listener registration order, which is mount order — and that puts an
// overlay's handler behind the surface it covers. Decides only WHICH surface
// handles a key; precedence within one stays with the defaultPrevented ladder.

export interface KeyboardClaim {
  readonly id: number
}

let nextId = 1
const claims: KeyboardClaim[] = []

export function claimKeyboard(): KeyboardClaim {
  const claim: KeyboardClaim = { id: nextId++ }
  claims.push(claim)
  return claim
}

// By identity, not popped: an overlay swap releases the old claim after the new
// one is taken.
export function releaseKeyboard(claim: KeyboardClaim | null): void {
  if (!claim) return
  const index = claims.indexOf(claim)
  if (index !== -1) claims.splice(index, 1)
}

export function isBaseSurfaceActive(): boolean {
  return !claims.length
}

// A released or absent claim is never on top: an unclaimed overlay is closed,
// not the base surface.
export function isClaimOnTop(claim: KeyboardClaim | null | undefined): boolean {
  return !!claim && claim === claims[claims.length - 1]
}
